export const getWindowWidth = () => window.innerWidth;
export const getWindowHeight = () => window.innerHeight;
